import { render } from "./VouchersShopPage.vue?vue&type=template&id=36ecbd89&scoped=true"
import script from "./VouchersShopPage.vue?vue&type=script&lang=js"
export * from "./VouchersShopPage.vue?vue&type=script&lang=js"

import "./VouchersShopPage.vue?vue&type=style&index=0&id=36ecbd89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ecbd89"]])

export default __exports__